import React from 'react';
import classNames from 'classnames';

export const BrowserIngestionEstimate =
  'This will take about 50% of the length of a typical video.';

type Props = {
  progressPercentage?: number | null;
  className?: string;
}

export function normalizeIngestionProgress(progressPercentage?: number | null): number {
  const value = typeof progressPercentage === 'number' && Number.isFinite(progressPercentage)
    ? progressPercentage
    : 0;

  return Math.min(100, Math.max(0, Math.round(value)));
}

export const IngestionProgress = ({ progressPercentage, className }: Props) => {
  const progress = normalizeIngestionProgress(progressPercentage);

  return (
    <div className={classNames('ingestion-progress', className)}>
      <span className="ingestion-progress-label">{progress}%</span>
      <div
        className="ingestion-progress-bar"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={progress}>
        <div
          className="ingestion-progress-bar-fill"
          style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
};
